"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SECRET_VISIBLE_LENGTH = exports.REGEX_DOMAIN = exports.NONCE_LENGTH = exports.LOCALHOST = exports.HTTPS = exports.HTTP = exports.HIDDEN_SECRET_CHAR = exports.HEX_CHARACTERS = void 0;
var HEX_CHARACTERS = exports.HEX_CHARACTERS = "0123456789ABCDEF",
  NONCE_LENGTH = exports.NONCE_LENGTH = 16,
  HTTP = exports.HTTP = "http://",
  HTTPS = exports.HTTPS = "https://",
  LOCALHOST = exports.LOCALHOST = "localhost",
  REGEX_DOMAIN = exports.REGEX_DOMAIN = /^(\.?(([a-zA-Z\d][a-zA-Z\d-]*[a-zA-Z\d])|[a-zA-Z\d]))(\.(([a-zA-Z\d][a-zA-Z\d-]*[a-zA-Z\d])|[a-zA-Z\d])){1,126}$/,
  HIDDEN_SECRET_CHAR = exports.HIDDEN_SECRET_CHAR = "*",
  SECRET_VISIBLE_LENGTH = exports.SECRET_VISIBLE_LENGTH = 4;